const MONTH_NAMES = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];
export function formatDate(datetime) {
	if (!datetime) return "-";
	const [date, monthNumber, year] = datetime.split(" ")[0].split("-");
	const monthName = MONTH_NAMES[monthNumber - 1];
	return `${monthName} ${date}, 20${year}`;
}
